import { useState, useEffect } from 'react';
import { projectRepositoriesAPI } from '../../services/api';

/**
 * Loads flattened project repositories when the repositories tab is active (same effect as Streams.js).
 */
export function useStreamRepositoriesAggregate({ activeStreamTab, orgId, streamId, projects }: any) {
  const [streamReposFlat, setStreamReposFlat] = useState<any[]>([]);
  const [streamReposLoading, setStreamReposLoading] = useState(false);

  useEffect(() => {
    if (
      (activeStreamTab !== 'repositories' &&
        activeStreamTab !== 'overview' &&
        activeStreamTab !== 'metrics') ||
      !orgId ||
      !streamId
    ) {
      return undefined;
    }
    let cancelled = false;
    setStreamReposLoading(true);
    const run = async () => {
      if (projects.length === 0) {
        if (!cancelled) {
          setStreamReposFlat([]);
          setStreamReposLoading(false);
        }
        return;
      }
      try {
        const batches = await Promise.all(
          projects.map((p) =>
            projectRepositoriesAPI.list(orgId, streamId, p.id).then((repos) =>
              (Array.isArray(repos) ? repos : []).map((r) => ({
                ...r,
                _projectId: p.id,
                _projectName: p.name,
              }))
            )
          )
        );
        if (!cancelled) setStreamReposFlat(batches.flat());
      } catch {
        if (!cancelled) setStreamReposFlat([]);
      } finally {
        if (!cancelled) setStreamReposLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [activeStreamTab, orgId, streamId, projects]);

  return { streamReposFlat, streamReposLoading };
}
